import { createFileRoute, redirect } from '@tanstack/react-router';

// Default deeplink: /informes → /informes/radiografia (la vista
// principal del módulo). Pre-cierre tiene su propia URL.
export const Route = createFileRoute('/_app/informes/')({
  beforeLoad: () => {
    throw redirect({ to: '/informes/radiografia' });
  },
});
